import { GameConstants } from './../../GameConstants';
import { GameVars } from "./../../GameVars";
import { Button } from "../../utils/Button";
import { Background } from "../background/Background";
import { Table } from "../room/Table";
import { AudioManager } from '../../managers/AudioManager';

export class AdversariesInfoLayer extends Phaser.GameObjects.Container {

    constructor(scene: Phaser.Scene) {

        super(scene);

        const background = new Background(this.scene);
        this.add(background);

        const table = new Table(this.scene);
        table.y = 380;
        table.setScale(.9 * GameVars.scaleX, .9);
        this.add(table);

        let backButton = new Button(this.scene, 35 * GameVars.scaleX, 35, "texture_atlas_1", "btn_menu.png", "btn_menu.png", true, true);
        backButton.scaleX = GameVars.scaleX;
        backButton.onUp(this.onClickBack, this);
        this.add(backButton);  

        if (GameConstants.SPONSOR === GameConstants.SPONSOR_FUNO) {
            backButton.x = GameConstants.GAME_WIDTH - 35 * GameVars.scaleX;
        }

        let midContainer = new Phaser.GameObjects.Container(this.scene);
        midContainer.x = GameConstants.GAME_WIDTH / 2;
        midContainer.scaleX = GameVars.scaleX;
        this.add(midContainer);

        let charImg = new Phaser.GameObjects.Image(this.scene, 0, 84, "texture_atlas_1", "char_file_zombie.png");
        midContainer.add(charImg);

        charImg = new Phaser.GameObjects.Image(this.scene, -162, 242, "texture_atlas_1", "char_file_moai.png");
        midContainer.add(charImg);

        charImg = new Phaser.GameObjects.Image(this.scene, 162, 242, "texture_atlas_1", "char_file_sloth.png");
        midContainer.add(charImg);

        charImg = new Phaser.GameObjects.Image(this.scene, -162, 400, "texture_atlas_1", "char_file_burger-teen.png");
        midContainer.add(charImg);

        charImg = new Phaser.GameObjects.Image(this.scene, 162, 400, "texture_atlas_1", "char_file_demon.png");
        midContainer.add(charImg);

        charImg = new Phaser.GameObjects.Image(this.scene, -162, 558, "texture_atlas_1", "char_file_monkey.png");
        midContainer.add(charImg);

        charImg = new Phaser.GameObjects.Image(this.scene, 162, 558, "texture_atlas_1", "char_file_richMan.png");
        midContainer.add(charImg);

        this.visible = false;
    }

    private onClickBack(): void {

        AudioManager.playSound("btn_click");

        this.visible = false;
    }
}
